import { GameConfigType, LatestDateItemType } from '@/pages/dashboard/types/dashboard';
import moment from 'moment';
import dashboardRequest from '../utils/dashboardRequest';
import { setCustomFilterList } from '../components/NewFilter/customFilterList';

// 获取筛选器等配置
export const getGameConfig: (gameCode: string) => Promise<GameConfigType> = (gameCode) => dashboardRequest({
  url: '/api/v1/dashboard/config',
  method: 'post',
  data: {
    game_code: gameCode
  }
}) as Promise<GameConfigType>;

// 获取筛选器
export const getSelector: (gameCode: string, api?: string, selector_list?: string[], path?: string) => Promise<any> = (gameCode, api, selector_list, path) => dashboardRequest({
  url: api || '/api/v1/dashboard/new_selector',
  method: 'post',
  data: {
    game_code: gameCode,
    selector_list: selector_list ? selector_list : [],
    // 和后端核对后，path可传空字符串
    path: path ? path : ''
  },
  formatData: (data: any): any => {
    const {custom_filters: customFilters, ...otherData} = data || {};
    // 自定义筛选器列表
    const customFiltersKey = Object.keys(customFilters || {});
    setCustomFilterList(customFiltersKey, true);
    return {...(otherData || {}), ...(customFilters || {})};
  }
}) as Promise<any>;

// 获取筛选器
export const getLatestDate = (gameCode: string, type: string): Promise<LatestDateItemType> => dashboardRequest({
  url: '/api/v1/dashboard/get_latest_date',
  method: 'post',
  errorHandler: true,
  data: {
    game_code: gameCode,
    last_data_metric: type
  },
  formatData: (data: any): LatestDateItemType => {
    const { last_date: lastDate } = data || {};
    const { daily_date: date, hour_date: hour, monthly_date: month, weekly_date: week } = lastDate;
    // 当最新值为空的时候默认取今天
    return {
      date: date ? moment(date).format('YYYY-MM-DD') : moment().format('YYYY-MM-DD'),
      hour: hour ? moment(hour).format('YYYY-MM-DD') : moment().format('YYYY-MM-DD'),
      month: month ? moment(month).format('YYYY-MM-DD') : moment().format('YYYY-MM-DD'),
      week: week ? moment(week).format('YYYY-MM-DD') : moment().format('YYYY-MM-DD')
    };
  }
}) as Promise<LatestDateItemType>;


// 获取筛选器方案
export const getSelectorSchemeList: (gameCode: string, path?: string) => Promise<any> = (gameCode, path?) => dashboardRequest({
  url: '/api/v1/dashboard/filter/list',
  method: 'post',
  data: {
    game_code: gameCode,
    page_path: path
  }
}) as Promise<any>;

// 添加筛选器方案
export const addSelectorSchemeList: (param: any) => Promise<any> = (param) => dashboardRequest({
  url: '/api/v1/dashboard/filter/add',
  method: 'post',
  data: param
}) as Promise<any>;

// 编辑筛选器方案
export const editSelectorSchemeList: (param: any) => Promise<any> = (param) => dashboardRequest({
  url: '/api/v1/dashboard/filter/edit',
  method: 'post',
  data: param
}) as Promise<any>;

// 删除筛选器方案
export const deleteSelectorSchemeList: (gameCode: string, id: number) => Promise<any> = (gameCode, id) => dashboardRequest({
  url: '/api/v1/dashboard/filter/delete',
  method: 'post',
  data: {
    game_code: gameCode,
    id,
  }
}) as Promise<any>;

